import React from 'react';
import { Tooltip } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';

export const ToolTip = ({ label }: any): JSX.Element => {
  return (
    <Tooltip
      placement="left"
      title={label}
      data-testid="NationalAccountTooltip"
    >
      <InfoFilled size="small" color="info" />
    </Tooltip>
  );
};
